<!-- Begin: Admin Form -->
<div class="mw1000 center-block">

    <div class="admin-form" style="margin-top: 100px;">

        <div class="panel heading-border">
            <div class="panel-body bg-light">
                <form ngNativeValidate [formGroup]="forma" (ngSubmit)="createCompany()" method="post" id="form-ui">
                    <!---->
                    <div class="section-divider mb40" id="spy1">
                        <span>Create your company</span>
                    </div>
                    <!-- .section-divider -->

                    <!-- Basic Inputs -->
                    <div class="row">

                        <div class="col-md-3">


                        </div>

                        <div class="col-md-6">

                            <div class="row">
                                <div class="col-md-12" style="text-align: center">
                                    <img *ngIf="urlImg" [src]="urlImg" style="width: 180px; height: 180px;" class="img-thumbnail rounded " />


                                    <div class="section" style="width: 38%; margin-left: 31%; margin-bottom: 7%;">
                                        <label class="field prepend-icon file">
                                  <span class="button">Open</span>
                                  <input type="file" class="gui-file" name="file2" id="file2" (change)="cambioArchivo($event)">
                                  <input type="text" class="gui-input" id="uploader3" placeholder="File">
                                  <label class="field-icon">
                                    <i class="fa fa-upload"></i>
                                  </label>
                                        </label>
                                        <div *ngIf="activo" class="progress" style="height: 20px;">
                                            <div class="progress-bar progress-bar-primary" role="progressbar" [ngStyle]="{ width: total + '%' }" attr.aria-valuenow=" {{ total }} " aria-valuemin="0" aria-valuemax="100">
                                                {{ total }} %
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col-md-12 ">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Company</mat-label>

                                          <input matInput type="text" placeholder="companyname"  formControlName="companyname">
                                          <mat-icon matSuffix> user </mat-icon>

                                        </mat-form-field>

                                    </div>
                                </div>

                            </div>


                            <div class="row">
                                <div class="col-md-12">
                                    <div class="section ">

                                      <app-google-places (setAddress)="getAddress($event)" adressType="geocode"></app-google-places>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">

                                    <div class="section ">

                                      <!-- <label class="field select ">
                                        <select id="typecompany" formControlName="typecompany" name="typecompany">
                                        <option value=" ">Select Role User</option>
                                        <option value="1 ">Admin</option>
                                        <option value="2 ">User</option>
                                        <option value="3 ">Driver</option>
                                        </select>
                                        <i class="arrow "></i>
                                    </label>-->

                                    <mat-select formControlName="typecompany">

                                      <mat-option value="0">Inactive </mat-option>
                                      <mat-option value="1">Admin  </mat-option>
                                      <mat-option value="2">User </mat-option>
                                      <mat-option value="3">Driver  </mat-option>
                                  </mat-select>

                                    </div>
                                </div>

                            </div>




                            <div class="row" style="margin-bottom: 10px;">
                                <div class="col-md-12 ">

                                  <mat-form-field class="example-full-width">
                                    <mat-label>Description</mat-label>
                                    <textarea matInput placeholder="Description" formControlName="description" id="description" name="description" rows=5></textarea>
                                  </mat-form-field>

                                  <!--   <label class="field prepend-icon ">
                                      <textarea class="gui-textarea" id="description" formControlName="description" name="description" placeholder="Text area"></textarea>
                                      <label for="comment" class="field-icon">
                                      <i class="fa fa-comments"></i>
                                      </label>
                                    <span class="input-footer ">
                                  <strong>Hint:</strong>Don't be negative or off topic! just be awesome...</span>
                                    </label> -->

                                </div>

                            </div>

                            <div class="row ">


                            </div>

                        </div>
                    </div>










                    <!--   <div class="section-divider mt40 mb25 " id="spy6 ">
                  <span>Toggle Switches</span>
              </div>


              <div class="section row ">
                  <div class="col-md-6 col-md-3 ">
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f1 " value="javascript ">
<label for="f1 " data-on="ON " data-off="OFF "></label>
                      <span>Javascript</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f2 " value="downloads ">
<label for="f2 " data-on="ON " data-off="OFF "></label>
                      <span>Downloads</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f3 " value="cookies ">
<label for="f3 " data-on="ON " data-off="OFF "></label>
                      <span>Cookies</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f4 " value="popups " checked>
<label for="f4 " data-on="ON " data-off="OFF "></label>
                      <span>Popups</span>
                      </label>
                  </div>


                  <div class="hidden-xs col-md-3 ">
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t1 " value="analytics ">
<label for="t1 " data-on="YES " data-off="NO "></label>
                      <span>Analytics</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t2 " value="reports ">
<label for="t2 " data-on="YES " data-off="NO "></label>
                      <span>Reports</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t3 " value="social ">
<label for="t3 " data-on="YES " data-off="NO "></label>
                      <span>Social</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t4 " value="admin " checked>
<label for="t4 " data-on="YES " data-off="NO "></label>
                      <span>Access</span>
                      </label>
                  </div>


                  <div class="col-md-6 col-md-3 ">
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr1 " value="mootols ">
<label for="fr1 " data-on="ON " data-off="OFF "></label>
                      <span>MooTools</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr2 " value="angular ">
<label for="fr2 " data-on="ON " data-off="OFF "></label>
                      <span>Angular JS</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr3 " value="jquery ">
<label for="fr3 " data-on="ON " data-off="OFF "></label>
                      <span>jQuery</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr4 " value="dojo " checked>
<label for="fr4 " data-on="ON " data-off="OFF "></label>
                      <span>Dojo</span>
                      </label>
                  </div>


                  <div class="hidden-xs col-md-3 ">
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr5 " value="mootols ">
<label for="fr5 " data-on="YES " data-off="NO "></label>
                      <span>MooTools</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr6 " value="angular ">
<label for="fr6 " data-on="YES " data-off="NO "></label>
                      <span>Angular JS</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr7 " value="jquery ">
<label for="fr7 " data-on="YES " data-off="NO "></label>
                      <span>jQuery</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr8 " value="dojo " checked>
<label for="fr8 " data-on="YES " data-off="NO "></label>
                      <span>Dojo</span>
                      </label>
                  </div>

              </div> -->
                    <!-- end .section row section -->


                    <!-- end .form-body section -->
                    <div class="panel-footer text-center ">
                        <button type="submit " class="button btn-primary ">Guardar</button>
                    </div>
                    <!-- end .form-footer section -->
                </form>
            </div>
        </div>

    </div>
</div>
